import React from 'react';

import { Header, Eyebrow } from 'formlabs-web-components/Type';
import Card from '../../../../common/components/content/Card';

import './Resources.module.css';

const List = ({ resources }) => (
  <div styleName="posts">
    {resources.map(resource => {
      return (
        <div key={resource.id} styleName="post-wrapper">
          <div styleName="post-sizing">
            <Card
              url={resource.url}
              imageConstraint="300px"
              imagePosition="left"
              bgColor="transparent-black"
              image={resource.listing_image}
              padding="35px 0"
              hover="light-grey"
            >
              <div styleName="post-eyebrows">
                <Eyebrow color="blue">{resource.type}</Eyebrow>
              </div>
              <Header level={4} displayAs={4} weight={400}>
                {resource.title}
              </Header>
            </Card>
          </div>
        </div>
      );
    })}
  </div>
);

export default List;
